import { Link } from "react-router-dom";
import { ArrowBigRight, BriefcaseBusiness } from "lucide-react";
import { BillingEventData } from "@/common/types/billing/event.type";
import { formatCurrency, formatDateTime } from "@/common/utils/formatters";
import CompanyConsumptionDetails from "@/features/privateCompanies/components/companyConsumptionDetails";
import CompanyRefundDetails from "@/features/privateCompanies/components/companyRefundDetails";
import React from "react";
import { billingEventsFiscalDocumentsStatus } from "../constants/eventsFiscalDocumentsStatusOptions.constant";
import { eventableTypeTranslations } from "@/features/privateCompanies/services/companyBillingEventTransformer";
import { ImageWithPlaceholder } from "@/common/components/ImageWithPlaceholder";

export class BillingEventsFiscalDocumentsTransformer {
  static tableTransformer() {
    return (events: BillingEventData[]) => {
      return events.map((event) => {
        return {
          ...event,
          status: event.eventable?.fiscal_document_status ? billingEventsFiscalDocumentsStatus[event.eventable?.fiscal_document_status as keyof typeof billingEventsFiscalDocumentsStatus] : '',
          type: event.eventable_type ? eventableTypeTranslations[event.eventable_type] : '',
          details: eventableDetailsComponent[event.eventable_type] ? React.createElement(eventableDetailsComponent[event.eventable_type], { data: event.eventable }) : '',
          total_amount: event.total_amount ? formatCurrency(event.total_amount) : '',
          client_company: event.eventable?.client_branch?.general_information && (
            <div className="flex items-center gap-2 w-max">
              <ImageWithPlaceholder
                placeholderIcon={BriefcaseBusiness}
                className="w-6 h-6"
                iconClassName="w-4 h-4"
                url={event.eventable?.client_branch?.general_information?.company_logo?.url}
              />

              <p>
                {event.eventable?.client_branch?.general_information?.fantasy_name}
              </p>
            </div>
          ),
          client_company_branch: event.eventable?.client_branch?.display_name,
          created_at: formatDateTime(new Date(event.created_at)),
          action: (
            <Link to={event.id}>
              <ArrowBigRight />
            </Link>
          ),
          _className: event.eventable?.fiscal_document_status === 'rejected' ? 'bg-yellow-op-2' : ''
        };
      });
    };
  }

  static quickSearchModelTransformer() {
    return (events: BillingEventData[]) => {
      return events.map((event) => ({
        route: `/events-with-fiscal-document-requirement/${event.id}`,
        items: [
          ['Transação', event.protocol_number],
          ['Tipo', event.eventable_type ? eventableTypeTranslations[event.eventable_type] : ''],
          ['Status', event.eventable?.fiscal_document_status ? billingEventsFiscalDocumentsStatus[event.eventable?.fiscal_document_status as keyof typeof billingEventsFiscalDocumentsStatus] : ''],
          ['Estabelecimento', event.eventable?.establishment_branch?.general_information?.fantasy_name],
          ['Empresa', event.eventable?.client_branch?.general_information?.fantasy_name],
        ]
      }));
    };
  }
}

export const eventableDetailsComponent: { [key: string]: React.ComponentType<any>; } = {
  'Client::Consumption': CompanyConsumptionDetails,
  'Billing::Refund': CompanyRefundDetails,
};
